import { AbstractFacade, plainToInstanceWithLVS } from '@goparrot/common';
import deepmerge from 'deepmerge';
import { ReadFranchiseStoreDto } from '../generated-dto';
import { StoreExposeGroup } from '../interface';
export class FranchiseStoreFacade extends AbstractFacade {
    constructor(config = {}, interceptors = {}) {
        super(deepmerge({
            axiosConfig: {
                baseURL: process.env.GOPARROT_PLATFORM_SERVICE_STORE_V2,
            },
        }, config), interceptors);
        this.basePrefix = '/api/v2/merchants';
    }
    async list(merchantId, query) {
        return plainToInstanceWithLVS(ReadFranchiseStoreDto, (await this.client.get(`${this.basePrefix}/${merchantId}/franchise-stores`, {
            params: query,
        })).data, {
            groups: [StoreExposeGroup.READ],
        });
    }
}
//# sourceMappingURL=franchise-store.facade.js.map